import Vue from 'vue'
import Vuex from 'vuex'

// Modulos //
import common from './store/common'

import autorizador from './store/autorizador'
import conciliacao from './store/conciliacao'
import confirmMessage from './store/confirm-message'
import documents from './store/documents'
import formRules from './store/form-rules'
import notifications from './store/notifications'
import notasFiscais from './store/notas-fiscais'
import permissions from './store/permissions'
import request from './store/request'
import recebiveis from './store/recebiveis'
import router from './router/router'
import userData from './store/user-data'
import faturamento from './store/faturamento'
import tutorial from './store/tutorial'
import authenticator from './store/authenticator'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    autorizador,
    common,
    conciliacao,
    confirmMessage,
    documents,
    formRules,
    notifications,
    notasFiscais,
    permissions,
    request,
    recebiveis,
    router,
    userData,
    faturamento,
    tutorial,
    authenticator,
  },
  state: {

    userLoged: {},
    loader: {
      loaderOn: false,
      linearLoader: true,
      circleLoader: false
    },
    showMenu: false,
    docTipos: [
      {
        doc_Tipo: "Relatorio",
        id: "Relatorio",
      },
      {
        doc_Tipo: "Manual",
        id: "Manual",
      },
      {
        doc_Tipo: "Checklist",
        id: "Checklist",
      },
    ],
  },
  actions: {

  },
  mutations: {
    updateUserLoged: (state, obj) => {
      state.userLoged = obj
    },
    showLoader: (state, opts) => {
      if (opts && opts.circle) {
        state.loader.linearLoader = false
        state.loader.circleLoader = true
      } else {
        state.loader.linearLoader = true
        state.loader.circleLoader = false
      }
      state.loader.loaderOn = true
    },
    hideLoader: state => (state.loader.loaderOn = false),
    toogleMenu: (state, newStatus) => (state.showMenu = newStatus),
  }
})
